// Small DOM construction helper: h('button.primary', { onClick, title }, 'Save')

export function h(tag, props = {}, ...children) {
  const [name, ...classes] = tag.split('.')
  const el = document.createElement(name || 'div')
  if (classes.length) el.className = classes.join(' ')

  for (const [key, value] of Object.entries(props ?? {})) {
    if (value == null) continue
    if (key === 'class') {
      el.className = el.className ? `${el.className} ${value}` : value
    } else if (key === 'dataset') {
      Object.assign(el.dataset, value)
    } else if (key === 'style' && typeof value === 'object') {
      for (const [prop, v] of Object.entries(value)) {
        if (prop.startsWith('--')) el.style.setProperty(prop, v)
        else el.style[prop] = v
      }
    } else if (key.startsWith('on') && typeof value === 'function') {
      el.addEventListener(key.slice(2).toLowerCase(), value)
    } else if (key in el && key !== 'list' && typeof value !== 'string') {
      el[key] = value
    } else {
      el.setAttribute(key, value)
    }
  }

  append(el, children)
  return el
}

function append(el, child) {
  if (child == null || child === false) return
  if (Array.isArray(child)) {
    for (const c of child) append(el, c)
  } else if (child instanceof Node) {
    el.appendChild(child)
  } else {
    el.appendChild(document.createTextNode(String(child)))
  }
}

export function clear(node) {
  while (node.firstChild) node.firstChild.remove()
  return node
}
